import { getController } from '@/services/service'

const url = 'changelog'

export const changelogService = {
	...getController<Api.Changelog>(url),
}

export default changelogService
